import type { AnalyticsEvent } from './types';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Internal-only. GTM's snippet (index.html) already initializes
 * `window.dataLayer` before this module ever runs; the `|| []` here is just
 * defensive (e.g. an ad blocker strips the GTM script). Nothing outside
 * `lib/analytics` should touch `window.dataLayer` directly — go through the
 * semantic functions in `events.ts` instead.
 */
export function pushToDataLayer(payload: AnalyticsEvent): void {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);

  // `import.meta.env` is a Vite-only injection (always defined in the three
  // bundled frontends). The optional chain keeps this module truly portable —
  // importable under plain Node (where `import.meta.env` is undefined) so the
  // wrappers can be unit-tested without a bundler — while staying identical at
  // runtime in every browser build.
  if (import.meta.env?.DEV) {
    console.debug('[analytics]', payload);
  }
}
